(() => {
  const OBUMA_CART_ATTRIBUTE_NAME = 'shoppingcart-tags';
  const OBUMA_CART_ATTRIBUTE_VALUE = 'boleta';

  function getCartUpdateUrl() {
    const root = window.Shopify?.routes?.root || '/';
    return `${root}cart/update.js`;
  }

  async function setObumaCartAttributes(options = {}) {
    const formData = new FormData();
    formData.append(`attributes[${OBUMA_CART_ATTRIBUTE_NAME}]`, OBUMA_CART_ATTRIBUTE_VALUE);

    const response = await fetch(getCartUpdateUrl(), {
      method: 'POST',
      body: formData,
      credentials: 'same-origin',
      keepalive: Boolean(options.keepalive),
    });

    if (!response.ok) {
      throw new Error(`Obuma cart attribute update failed: ${response.status}`);
    }
  }

  setObumaCartAttributes().catch((error) => {
    console.error('Error setting Obuma cart attribute:', error);
  });

  document.addEventListener(
    'submit',
    async (event) => {
      const form = event.target;

      if (!(form instanceof HTMLFormElement)) return;
      if (form.id !== 'cart-form') return;
      if (form.dataset.obumaAttributeReady === 'true') return;

      event.preventDefault();
      event.stopImmediatePropagation();

      try {
        await setObumaCartAttributes();
      } catch (error) {
        console.error('Error setting Obuma cart attribute before checkout:', error);
      }

      form.dataset.obumaAttributeReady = 'true';

      if (event.submitter && typeof form.requestSubmit === 'function') {
        form.requestSubmit(event.submitter);
      } else {
        const checkoutInput = document.createElement('input');
        checkoutInput.type = 'hidden';
        checkoutInput.name = 'checkout';
        checkoutInput.value = 'checkout';
        form.appendChild(checkoutInput);
        form.submit();
      }
    },
    true
  );

  document.addEventListener(
    'pointerdown',
    (event) => {
      const target = event.target;

      if (!(target instanceof Element)) return;

      const isAcceleratedCheckout = target.closest(
        'shopify-accelerated-checkout, shopify-accelerated-checkout-cart, .additional-checkout-buttons'
      );

      if (!isAcceleratedCheckout) return;

      setObumaCartAttributes({ keepalive: true }).catch((error) => {
        console.error('Error setting Obuma cart attribute before accelerated checkout:', error);
      });
    },
    true
  );
})();